import { render } from "./EntregaLupi.vue?vue&type=template&id=f54695d2"
import script from "./EntregaLupi.vue?vue&type=script&lang=js"
export * from "./EntregaLupi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__